import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialog } from '@bca-shared/components/confirm-dialog/confirm-dialog';
import { MiddleNameComponent } from '@bca-shared/components/middle-name/middle-name.component';
import { NotificationComponent } from '@bca-shared/components/notification/notification.component';
import { SwitchButtonComponent } from '@bca-shared/components/switch-button/switch-button.component';
import { ToolTipComponent } from '@bca-shared/components/tooltip/tool-tip.component';
import { CypressDirective } from '@bca-shared/directives/cypress.directive';
import {
  DialogActionsDirective,
  DialogContentDirective
} from '@bca-shared/directives/dialog-content.directives';
import { ForceLetterDirective } from '@bca-shared/directives/force-letter.directive';
import { ForceLowercaseDirective } from '@bca-shared/directives/force-lowercase.directive';
import { ForceUppercaseDirective } from '@bca-shared/directives/force-uppercase.directive';
import { NoSpaceDirective } from '@bca-shared/directives/no-space.directive';
import { PrivacySensitiveDirective } from '@bca-shared/directives/privacy-sensitive.directive';
import { ReceiptFooterVisibilityDirective } from '@bca-shared/directives/receipt-footer-visibility.directive';
import { StickyReceiptDirective } from '@bca-shared/directives/sticky-receipt.directive';
import { DateFormatPipe } from '@bca-shared/pipes/date-format.pipe';
import { DisplayImagePipe } from '@bca-shared/pipes/display-image.pipe';
import { DisplayNamePipe } from '@bca-shared/pipes/display-name.pipe';
import { DisplayServicesPipe } from '@bca-shared/pipes/display-services.pipe';
import { PriceFormatPipe } from '@bca-shared/pipes/price-format.pipe';
import { SubstringPipe } from '@bca-shared/pipes/sub-string.pipe';
import { TranslateModule } from '@ngx-translate/core';

import { ForceDashDirective } from './directives/force-dash.directive';
import { FormatInitialsIEDirective } from './directives/format-initials-ie.directive';
import { FormatInitialsDirective } from './directives/format-initials.directive';
import { NesFormControlDirective } from './directives/nes-form-directive.directive';
import { FormatReferencePipe } from './pipes/format-reference.pipe';

const dialogs = [ConfirmDialog];

const pipes = [
  PriceFormatPipe,
  DateFormatPipe,
  DisplayNamePipe,
  SubstringPipe,
  DisplayServicesPipe,
  DisplayImagePipe,
  FormatReferencePipe
];

const components = [
  ToolTipComponent,
  NotificationComponent,
  MiddleNameComponent,
  SwitchButtonComponent
];

const directives = [
  ForceLowercaseDirective,
  ForceUppercaseDirective,
  ForceDashDirective,
  ReceiptFooterVisibilityDirective,
  PrivacySensitiveDirective,
  ForceLetterDirective,
  NoSpaceDirective,
  CypressDirective,
  StickyReceiptDirective,
  DialogContentDirective,
  DialogActionsDirective,
  FormatInitialsDirective,
  FormatInitialsIEDirective,
  NesFormControlDirective
];

const declarations = [...pipes, ...components, ...directives, ...dialogs];

@NgModule({
  declarations,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule.forChild()],
  exports: declarations,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
